import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "mau_modal_asignar_profesional",
  ref: "modalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "aria-modal": "true",
  "aria-label": "Asignar profesional",
  role: "dialog"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-750px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "mau_modal_asignar_profesional_header"
}
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "mau_modal_asignar_profesional_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" })
], -1)
const _hoisted_7 = {
  class: "scroll-y",
  id: "mau_modal__demarcacion_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#mau_modal_asignar_profesional_header",
  "data-kt-scroll-wrappers": "#mau_modal_asignar_profesional_scroll",
  "data-kt-scroll-offset": "200px"
}
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { class: "alert alert-dismissible bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle fs-2hx text-primary me-4 mb-5 mb-sm-0" }, null, -1)
const _hoisted_11 = { class: "d-flex flex-column pe-0 pe-sm-10" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-12 fv-row" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_18 = { class: "col-lg-12 fv-row" }
const _hoisted_19 = { class: "modal-footer flex-center" }
const _hoisted_20 = {
  type: "reset",
  id: "mau_modal_asignar_profesional_cancel",
  class: "btn btn-light me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_21 = ["data-kt-indicator", "disabled"]
const _hoisted_22 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_23 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("dialogs.asignarProfesional.titulo")), 1),
          _hoisted_6
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", { innerHTML: _ctx.descripcion }, null, 8, _hoisted_12)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("formularios.asignarProfesional.tipologiaContrato.label")), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.tipologiaContrato,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipologiaContrato) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipologiasContrato, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.nombre,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("formularios.asignarProfesional.tipologiaJornada.label")), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.tipologiaJornada,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tipologiaJornada) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipologiasJornada, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.nombre,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", _hoisted_20, _toDisplayString(_ctx.$t("dialogs.cancelButton")), 1),
          _createElementVNode("button", {
            "data-kt-indicator": _ctx.loading ? 'on' : null,
            class: "btn btn-lg btn-primary",
            type: "submit",
            disabled: !_ctx.meta.valid,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("dialogs.okButton")), 1))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_25))
              : _createCommentVNode("", true)
          ], 8, _hoisted_21)
        ])
      ])
    ])
  ], 512))
}